import axios from 'axios';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import ReactPaginate from 'react-paginate'
import $ from 'jquery';
import React, { Component, useState } from 'react';
import Cookies from 'universal-cookie';
import "../services/ApiRest";
import swal from 'sweetalert';
import { ApiUrl } from '../services/ApiRest';
import { Alert } from 'bootstrap';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import * as xlsx from "xlsx";

const cookie = new Cookies();
const urlListaAsignatutasDoc = ApiUrl + "listarasigdocperiod" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const listarEstAsignatura = ApiUrl + "listestasignatura" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlModCalificacionEstAsign = ApiUrl + "modcalificacionestasign" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlIngresarCalificacionesAsign = ApiUrl + "ingcalificacionestasign" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

let listaauxiliar = [];
const itemsPerPage = 10;

export default class ListarAsignaturasDoc extends Component {
    constructor(props) {
        super(props)
        this.state = {
            estud: [],
            EstudianteBackup: [],
            ListEstAsign: [],
            ListEstAsignExcel: [],
            ListAsign: [],
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
            //variables globales
            form1: {
            },
            listaperiodos: [],
            periodo: 1,
            showResults: "none",
        }
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }

    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalRegistroPagoMatricula: false });
            this.setState({ modalModUsuario: false });
        }
    }
    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" });
        this.setState({ imgpersonalmod: e.target.files })

    }

    //controles del modal de  un registro de abono de matricula
    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);


        axios.get(urlListarPeriodos)
            .then(response => {
                const respuesta = response.data.data;
                this.setState({ listaperiodos: respuesta });
            })
        axios.post(urlListaAsignatutasDoc, {
            idDocente: cookie.get("idAdministrativo"),
            idPeriodoSelect: this.state.periodo,
        })
            .then(respuesta => {
                this.setState({ ListAsign: respuesta.data.data });
                //FIN DE LA PAGINACION
            })

    }


    //FIN DE PAGINACION
    ocultarModalModificar = () => {
        this.setState({ modalModificar: false });
    }
    ocultarModificarUsu = () => {
        this.setState({ modalModUsuario: false });
    }


    //Listar las asignaturas de los docentes
    handleAsignaturasPeriod = async (e) => {

        await this.setState({ [e.target.name]: e.target.value })

        axios.post(urlListaAsignatutasDoc, {
            idDocente: cookie.get("idAdministrativo"),
            idPeriodoSelect: this.state.periodo,
        })
            .then(respuesta => {
                this.setState({ ListAsign: respuesta.data.data });
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }


    mostrarModalModUsu = (registro) => {
        this.setState({ modalModUsuario: true, form1: registro });
    }

    seleccionarAsignuno = () => {
        var id_asignatura = 0;
        var id_paralelo = 0;
        var rol_docente = "";

        this.setState({ showResults: "block" });

        $(".afiliado:checked").each(function () {
            const fila = $(this).closest("tr");
            id_asignatura = fila.find("td").eq(0).html();
            id_paralelo = fila.find("td").eq(1).html();
            rol_docente = fila.find("td").eq(9).text().trim(); // Asegúrate que esta es la columna correcta
        });

        this.setState({ rolDocenteSeleccionado: rol_docente });

        axios
            .post(listarEstAsignatura, {
                idAsignatura: id_asignatura,
                idParalelo: id_paralelo,
                idPeriodo: this.state.periodo
            })
            .then(response => {
                const lista = response.data.data;
                const itemOffset = 0;
                const endOffset = itemOffset + itemsPerPage;

                this.setState({
                    ListEstAsignExcel: lista,
                    currentItems: lista.slice(itemOffset, endOffset),
                    EstudianteBackup: lista.slice(itemOffset, endOffset),
                    pageCount: Math.ceil(lista.length / itemsPerPage),
                    itemOffset: itemOffset
                });
            })
    };

    ocultarModalModCalificacionEst = () => {
        this.setState({ modalmodCalificacionEst: false });
    }

    actualizarValoresModal = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        var promparciales = this.promedioparciales(Number(this.state.parcial1), Number(this.state.parcial2), Number(this.state.parcial3));
        var promfinal = this.promediototal(Number(this.state.parcial1), Number(this.state.parcial2), Number(this.state.parcial3), Number(this.state.examenf), Number(this.state.examens));
        var equiv = (promfinal < 7 || this.state.asistencia < 70) ? "REPROBADO" : "APROBADO";
        $(function () {
            $("#proma").val(promparciales);
            $("#promf").val(promfinal);
            $("#equivalencia").val(equiv);
        });
        this.setState({ proma: promparciales });
        this.setState({ promf: promfinal });
        this.setState({ equivalencia: equiv });
    }

    mostrarModalModCalificacionEst = (registro) => {
        var promparciales = this.promedioparciales(registro.parcial1, registro.parcial2, registro.parcial3);
        var promfinal = this.promediototal(registro.parcial1, registro.parcial2, registro.parcial3, registro.examen_final, registro.examen_suspension);
        var parcial1convert = this.convertirDosDecimales(registro.parcial1);
        var parcial2convert = this.convertirDosDecimales(registro.parcial2);
        var parcial3convert = this.convertirDosDecimales(registro.parcial3);
        $(function () {
            $("#id").val(registro.id_matricula_asignatura);
            $("#estudiante").val(registro.primer_nombre_estudiante + " " + registro.segundo_nombre_estudiante + " " + registro.primer_apellido_estudiante + " " + registro.segundo_apellido_estudiante);
            $("#parcial1").val(parcial1convert);
            $("#parcial2").val(parcial2convert);
            $("#parcial3").val(parcial3convert);
            $("#proma").val(promparciales);
            $("#examenf").val(registro.examen_final);
            $("#examens").val(registro.examen_suspension);
            $("#promf").val(promfinal);
            $("#equivalencia").val(registro.equivalencia == 0 ? "REPROBADO" : "APROBADO");
            $("#asistencia").val(registro.asistencia);
        });
        this.setState({ modalmodCalificacionEst: true, form1: registro });
        this.setState({ id: registro.id_matricula_asignatura });
        this.setState({ estudiante: registro.primer_nombre_estudiante + " " + registro.segundo_nombre_estudiante + " " + registro.primer_apellido_estudiante + " " + registro.segundo_apellido_estudiante });
        this.setState({ parcial1: registro.parcial1 });
        this.setState({ parcial2: registro.parcial2 });
        this.setState({ parcial3: registro.parcial3 });
        this.setState({ proma: promparciales });
        this.setState({ examenf: registro.examen_final });
        this.setState({ examens: registro.examen_suspension });
        this.setState({ promf: promfinal });
        this.setState({ equivalencia: registro.equivalencia == 0 ? "REPROBADO" : "APROBADO" });
        this.setState({ asistencia: registro.asistencia });
    }

    promediototal = (p1, p2, p3, ef, es) => {
        var promp = (p1 + p2 + p3) / 3;
        var promp = (promp * 6) / 10;
        var examfinal = (ef * 4) / 10;
        var promacumulado = promp + examfinal;
        //  var promfinal = promacumulado >= 7 ? promacumulado : (promacumulado + es) / 2;
        var promfinal = 0.00;
        if (promacumulado >= 7) {
            promfinal = promacumulado;
        }
        else {
            if (((promacumulado >= 4) && (promacumulado < 7)) && (es == 0)) {
                promfinal = promacumulado;
            }
            else {

                if (((promacumulado >= 4) && (promacumulado < 7)) && (es > 0)) {
                    promfinal = (promacumulado + es) / 2;

                }
                else {
                    promfinal = promacumulado;
                }
            }
        }

        return (promfinal.toFixed(2))
    }
    //Convertir a dos decimales

    convertirDosDecimales = (nota) => {
        return (nota.toFixed(2))
    }

    promedioparciales = (p1, p2, p3) => {
        var promp = (p1 + p2 + p3) / 3;
        var promp = (promp * 6) / 10;
        return (promp.toFixed(2))
    }

    promediosobre4 = (p10) => {
        var prom4 = (p10 * 4) / 10;
        return (prom4.toFixed(2))
    }

    modificarCalificacionEstAsignatura = () => {
        var combmsmalert = "¿Está seguro que desea modificar la calificación?";
        var equiv = 0;
        if (Number(this.state.promf) >= 7 && this.state.asistencia >= 70) {
            equiv = 1;
        }

        swal({
            title: "Advertencia",
            text: combmsmalert,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {

                    axios
                        .post(urlModCalificacionEstAsign, {
                            id: this.state.id,
                            parcial1: this.state.parcial1,
                            parcial2: this.state.parcial2,
                            parcial3: this.state.parcial3,
                            examenf: this.state.examenf,
                            examens: this.state.examens,
                            equivalencia: equiv,
                            asistencia: this.state.asistencia,
                        })
                        .then(response => {
                            if (response.data.success === true) {
                                swal({
                                    text: "Datos procesados correctamente",
                                    icon: "success",
                                    button: "Aceptar",
                                });
                                this.seleccionarAsignuno();
                            } else {
                                swal({
                                    text: "No se actualizó los datos",
                                    icon: "error",
                                    button: "Aceptar",
                                });
                                this.setState({ modalmodDocAsignatura: false });

                            }
                        })
                        .catch(error => {
                            this.setState({ error: "No existe conexión con el servidor" });
                            swal({
                                text: "No existe conexión con el servidor",
                                icon: "error",
                                button: "Aceptar",

                            });
                        });
                } else {
                    swal({
                        text: "¡Haz denegado la acción!",
                        icon: "warning",
                        button: "Aceptar",
                    });
                }
            });
    }

    readUploadFile = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        //e.preventDefault();
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            }
        };
        if (e.target.files) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = e.target.result;
                const workbook = xlsx.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = xlsx.utils.sheet_to_json(worksheet);
                console.log(json);
                axios.post(urlIngresarCalificacionesAsign, {
                    calificaciones: json,
                }, axiosConfig)
                    .then(response => {
                        if (response.data.success === true) {
                            swal({
                                text: "Datos procesados correctamente",
                                icon: "success",
                                button: "Aceptar",
                            });
                            this.seleccionarAsignuno();
                        } else {
                            swal({
                                text: "No se actualizó los datos",
                                icon: "error",
                                button: "Aceptar",
                            });
                        }
                    })
                    .catch(error => {
                        this.setState({ error: "No existe conexión con el servidor" });
                        swal({
                            text: "No existe conexión con el servidor",
                            icon: "error",
                            button: "Aceptar",

                        });
                    });
            };
            reader.readAsArrayBuffer(e.target.files[0]);
            $(function () {
                $("#upload").val('');
            });
        }
    }

    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const { ListEstAsignExcel } = this.state;
        const newOffset = (event.selected * itemsPerPage) % ListEstAsignExcel.length;
        const endOffset = newOffset + itemsPerPage;

        this.setState({
            itemOffset: newOffset,
            currentItems: ListEstAsignExcel.slice(newOffset, endOffset),
            EstudianteBackup: ListEstAsignExcel.slice(newOffset, endOffset),
            pageCount: Math.ceil(ListEstAsignExcel.length / itemsPerPage)
        });
    };

    //BUSQUEDA......
    filter(event) {
        console.log(event.target.value);
        //obtener datos de buscar
        var text = event.target.value
        //obtener datos del array
        const data = this.state.ListEstAsignExcel;
        var newData = data.filter(function (item) {
            //variable del objeto
            const itemDataPrimerApell = item.primer_apellido_estudiante.toUpperCase()
            const itemDataPrimerNom = item.primer_nombre_estudiante.toUpperCase()
            const itemDataCedula = item.numero_identificacion_estudiante.toUpperCase()
            const campo = itemDataPrimerApell + " " + itemDataPrimerNom + " " + itemDataCedula;
            //variable del buscador
            const textData = text.toUpperCase()
            return campo.indexOf(textData) > -1
        })
        if (text == "") {
            newData = this.state.EstudianteBackup;
        }

        this.setState({
            currentItems: newData,
            //textBuscar: text,
        })
        console.log(this.state.currentItems)
    }

    render() {
        return (

            <div className="row animate__animated animate__fadeIn">

                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas d-flex align-items-center">
                        <i className="far fa-sticky-note me-2"></i>
                        <b>Calificaciones de Asignaturas</b>
                    </div>

                    <div className="p-3 rounded-3">
                        {/* — Selector de Período — */}
                        <div className="row g-3 mb-4">
                            <div className="col-md-6">
                                <label className="form-label text-azul small">
                                    Periodo Académico:
                                </label>
                                <select
                                    id="periodo"
                                    name="periodo"
                                    className="form-select form-select-sm"
                                    value={this.state.periodo}
                                    onChange={this.handleAsignaturasPeriod}
                                    required
                                >
                                    <option value="undefined" selecteddisabled>
                                        Seleccione el periodo
                                    </option>
                                    {this.state.listaperiodos &&
                                        this.state.listaperiodos.map(p => (
                                            <option
                                                key={p.id_periodo_academico}
                                                value={p.id_periodo_academico}
                                            >
                                                {p.descripcion_periodo_academico}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>

                        {/* — Tabla de Asignaturas — */}
                        <h6 className="fw-bold text-center mb-3 text-azul small">ASIGNATURAS</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-hover align-middle small">
                                <thead className="table-light">
                                    <tr>
                                        <th className="d-none" aria-hidden="true">#</th>
                                        <th className="d-none" aria-hidden="true">#</th>
                                        <th className="text-azul">Carrera</th>
                                        <th className="text-azul">Nivel</th>
                                        <th className="text-azul">Código</th>
                                        <th className="text-azul">Asignatura</th>
                                        <th className="text-azul">Paralelo</th>
                                        <th className="text-azul">Fecha Inicio</th>
                                        <th className="text-azul">Fecha Fin</th>
                                        <th className="text-azul">Rol</th>
                                        <th className="text-azul">Estado Acta</th>
                                        <th className="text-azul">Seleccionar</th>
                                    </tr>
                                </thead>
                                <tbody className="text-azul">
                                    {this.state.ListAsign &&
                                        this.state.ListAsign.map(item => (
                                            <tr key={item.id_asignatura}>
                                                {/* celdas ocultas para lógica */}
                                                <td className="oculto" style={{ display: 'none' }}>
                                                    {item.id_asignatura}
                                                </td>
                                                <td className="oculto" style={{ display: 'none' }}>
                                                    {item.paralelo}
                                                </td>
                                                {/* columnas visibles */}
                                                <td>{item.descripcion_carrera}</td>
                                                <td>{item.nivel_asignatura}</td>
                                                <td>{item.codigo_asignatura}</td>
                                                <td>{item.descripcion_asignatura}</td>
                                                <td>{item.nombre_paralelo}</td>
                                                <td>{item.fecha_inicio_asignatura}</td>
                                                <td>{item.fecha_fin_asignatura}</td>
                                                <td>{item.rol_docente}</td>
                                                <td>
                                                    <span className={item.estadoacta === 0 ? 'text-warning small' : 'text-success small'}>
                                                        {item.estadoacta === 0 ? 'Pendiente' : 'Entregado'}
                                                    </span>
                                                </td>
                                                <td className='text-center'>
                                                    <input
                                                        type="radio"
                                                        name="afiliado"
                                                        className="afiliado"
                                                        onChange={this.seleccionarAsignuno}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Estudiantes de la asignatura */}
                    <div className="row" style={{ display: this.state.showResults }}>
                        <div className="col-12">
                            <h6 className="fw-bold text-center my-3 text-azul small">
                                ESTUDIANTES DE LA ASIGNATURA
                            </h6>

                            <div className="row g-3 mb-3 justify-content-center">
                                <div className="col-12 col-md-6">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={this.state.text}
                                        placeholder="Buscar..."
                                        onChange={e => this.filter(e)}
                                    />
                                </div>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-sm table-hover align-middle small">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-azul">ID</th>
                                            <th className="text-azul">Estudiante</th>
                                            <th className="text-azul">P1</th>
                                            <th className="text-azul">P2</th>
                                            <th className="text-azul">P3</th>
                                            <th className="text-azul">Prom. Parcial / 6</th>
                                            <th className="text-azul">Examen Final / 4</th>
                                            <th className="text-azul">Suspensión / 10</th>
                                            <th className="text-azul">Prom. Final / 10</th>
                                            <th className="text-azul">Estado</th>
                                            <th className="text-azul">% Asistencia</th>
                                            {this.state.rolDocenteSeleccionado === "Principal" && (
                                                <th className="text-azul">Acción</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody className="text-azul">
                                        {this.state.currentItems?.map(est => (
                                            <tr key={est.id_matricula_asignatura}>
                                                <td>{est.id_matricula_asignatura}</td>
                                                <td>
                                                    {`${est.primer_apellido_estudiante} ${est.segundo_apellido_estudiante} ${est.primer_nombre_estudiante} ${est.segundo_nombre_estudiante}`}
                                                </td>
                                                <td>{this.convertirDosDecimales(est.parcial1)}</td>
                                                <td>{this.convertirDosDecimales(est.parcial2)}</td>
                                                <td>{this.convertirDosDecimales(est.parcial3)}</td>
                                                <td>{this.promedioparciales(est.parcial1, est.parcial2, est.parcial3)}</td>
                                                <td>{this.promediosobre4(est.examen_final)}</td>
                                                <td>{est.examen_suspension}</td>
                                                <td>
                                                    {this.promediototal(
                                                        est.parcial1,
                                                        est.parcial2,
                                                        est.parcial3,
                                                        est.examen_final,
                                                        est.examen_suspension
                                                    )}
                                                </td>
                                                <td>{est.equivalencia === 0 ? "REPROBADO" : "APROBADO"}</td>
                                                <td>{est.asistencia}</td>
                                                {this.state.rolDocenteSeleccionado === "Principal" && (
                                                    <td className="text-center">
                                                        <button
                                                            className="btn btn-sm btn-outline-primary"
                                                            onClick={() => this.mostrarModalModCalificacionEst(est)}
                                                        >
                                                            <i className="fas fa-clipboard-list"></i>
                                                        </button>
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <table id="tablaasignaturasexcel" className="table text-left" hidden>
                                    <thead >
                                        <tr>
                                            <th scope="col">ID</th>
                                            <th scope="col">ESTUDIANTE</th>
                                            <th scope="col">P1</th>
                                            <th scope="col">P2</th>
                                            <th scope="col">P3</th>
                                            <th scope="col">PROMEDIO_PARCIAL_6</th>
                                            <th scope="col">EXAMEN_FINAL_10</th>
                                            <th scope="col">SUSPENSION_10</th>
                                            <th scope="col">PROMEDIO FINAL / 10</th>
                                            <th scope="col">ESTADO</th>
                                            <th scope="col">ASISTENCIA</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.ListEstAsignExcel.map(consola => (
                                            <tr key={consola.id_matricula_asignatura}>
                                                <td class="mes">{consola.id_matricula_asignatura}</td>
                                                <td class="mes">{consola.primer_apellido_estudiante + " " + consola.segundo_apellido_estudiante + " " + consola.primer_nombre_estudiante + " " + consola.segundo_nombre_estudiante}</td>
                                                <td class="mes">{this.convertirDosDecimales(consola.parcial1)}</td>
                                                <td class="mes">{this.convertirDosDecimales(consola.parcial2)}</td>
                                                <td class="mes">{this.convertirDosDecimales(consola.parcial3)}</td>
                                                <td class="mes">{this.promedioparciales(consola.parcial1, consola.parcial2, consola.parcial3)}</td>
                                                <td class="mes">{consola.examen_final}</td>
                                                <td class="mes">{consola.examen_suspension}</td>
                                                <td class="mes">{this.promediototal(consola.parcial1, consola.parcial2, consola.parcial3, consola.examen_final, consola.examen_suspension)}</td>
                                                <td class="mes">{consola.equivalencia == 0 ? "REPROBADO" : "APROBADO"}</td>
                                                <td class="mes">{consola.asistencia}</td>
                                                <td class="detalle">
                                                    <button onClick={() => this.mostrarModalModCalificacionEst(consola)} > <i className=" fas fa-clipboard-list" ></i></button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="d-flex justify-content-center mt-1">
                                <ReactPaginate
                                    previousLabel="<"
                                    nextLabel=">"
                                    pageCount={this.state.pageCount}
                                    onPageChange={this.handlePageClick}
                                    containerClassName="pagination pagination-sm-custom"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    activeClassName="active"
                                />
                            </div>

                            {/* Exportar / Subir */}
                            {this.state.rolDocenteSeleccionado === "Principal" && (
                                <div className="row g-3 my-2 text-center">
                                    <div className="col-12 col-md-6">
                                        <ReactHTMLTableToExcel
                                            id="botonExportarExcel"
                                            className="btn btn-sm btn-success"
                                            table="tablaasignaturasexcel"
                                            filename="matrizcalificacionesexcel"
                                            sheet="pagina 1"
                                            buttonText="Descargar Plantilla"
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <input
                                            type="file"
                                            id="upload"
                                            className="form-control form-control-sm"
                                            onChange={this.readUploadFile}
                                        />
                                    </div>
                                </div>
                            )}

                            {/* Modal de modificación de calificación */}
                            <Modal isOpen={this.state.modalmodCalificacionEst}>
                                <ModalHeader>
                                    <div className="small mb-0 text-white">Modificar Calificación</div>
                                </ModalHeader>
                                <ModalBody>
                                    <FormGroup>
                                        <div className="row g-3">
                                            {/* ID oculto */}
                                            <input
                                                type="hidden"
                                                id="id"
                                                name="id"
                                                onChange={this.handleChange}
                                            />

                                            {/* Estudiante (solo lectura) */}
                                            <div className="col-12">
                                                <label className="form-label text-azul small">Estudiante</label>
                                                <input
                                                    type="text"
                                                    id="estudiante"
                                                    name="estudiante"
                                                    className="form-control form-control-sm"
                                                    defaultValue={this.state.formCal?.estudiante}
                                                    disabled
                                                />
                                            </div>

                                            {/* Parciales */}
                                            <div className="col-12 col-md-4">
                                                <label className="form-label text-azul small">Parcial 1 (10)</label>
                                                <input
                                                    type="text"
                                                    id="parcial1"
                                                    name="parcial1"
                                                    className="form-control form-control-sm"
                                                    defaultValue={this.state.formCal?.parcial1}
                                                    onChange={this.actualizarValoresModal}
                                                />
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <label className="form-label text-azul small">Parcial 2 (10)</label>
                                                <input
                                                    type="text"
                                                    id="parcial2"
                                                    name="parcial2"
                                                    className="form-control form-control-sm"
                                                    defaultValue={this.state.formCal?.parcial2}
                                                    onChange={this.actualizarValoresModal}
                                                />
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <label className="form-label text-azul small">Parcial 3 (10)</label>
                                                <input
                                                    type="text"
                                                    id="parcial3"
                                                    name="parcial3"
                                                    className="form-control form-control-sm"
                                                    defaultValue={this.state.formCal?.parcial3}
                                                    onChange={this.actualizarValoresModal}
                                                />
                                            </div>

                                            {/* Promedio Parciales (6) */}
                                            <div className="col-12 col-md-4">
                                                <label className="form-label text-azul small">Promedio Acumulado (6)</label>
                                                <input
                                                    type="text"
                                                    id="proma"
                                                    name="proma"
                                                    className="form-control form-control-sm"
                                                    defaultValue={this.state.formCal?.proma}
                                                    disabled
                                                />
                                            </div>

                                            {/* Examen Final (4) */}
                                            <div className="col-12 col-md-4">
                                                <label className="form-label text-azul small">Examen Final (4)</label>
                                                <input
                                                    type="text"
                                                    id="examenf"
                                                    name="examenf"
                                                    className="form-control form-control-sm"
                                                    defaultValue={this.state.formCal?.examenf}
                                                    onChange={this.actualizarValoresModal}
                                                />
                                            </div>

                                            {/* Examen Suspensión (10) */}
                                            <div className="col-12 col-md-4">
                                                <label className="form-label text-azul small">Examen Suspensión (10)</label>
                                                <input
                                                    type="text"
                                                    id="examens"
                                                    name="examens"
                                                    className="form-control form-control-sm"
                                                    defaultValue={this.state.formCal?.examens}
                                                    onChange={this.actualizarValoresModal}
                                                />
                                            </div>

                                            {/* Promedio Final (10) */}
                                            <div className="col-12 col-md-6">
                                                <label className="form-label text-azul small">Promedio Final (10)</label>
                                                <input
                                                    type="text"
                                                    id="promf"
                                                    name="promf"
                                                    className="form-control form-control-sm"
                                                    defaultValue={this.state.formCal?.promf}
                                                    disabled
                                                />
                                            </div>

                                            {/* Estado */}
                                            <div className="col-12 col-md-6">
                                                <label className="form-label text-azul small">Estado</label>
                                                <input
                                                    type="text"
                                                    id="equivalencia"
                                                    name="equivalencia"
                                                    className="form-control form-control-sm"
                                                    defaultValue={this.state.formCal?.equivalencia === 0 ? 'REPROBADO' : 'APROBADO'}
                                                    disabled
                                                />
                                            </div>

                                            {/* Asistencia */}
                                            <div className="col-12">
                                                <label className="form-label text-azul small">Asistencia (%)</label>
                                                <input
                                                    type="text"
                                                    id="asistencia"
                                                    name="asistencia"
                                                    className="form-control form-control-sm"
                                                    defaultValue={this.state.formCal?.asistencia}
                                                    onChange={this.actualizarValoresModal}
                                                />
                                            </div>
                                        </div>
                                    </FormGroup>
                                </ModalBody>

                                <ModalFooter>
                                    <button
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={this.modificarCalificacionEstAsignatura}
                                    >
                                        Modificar
                                    </button>
                                    <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={this.ocultarModalModCalificacionEst}
                                    >
                                        Salir
                                    </button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

